<template>
    <input data-allow-mismatch type="text" ref="input" readonly v-model="_value" :placeholder="placeholder">
</template>
<script src="./mvt-inputdate.js"></script>